import { render } from "./AdmCreateCourt.vue?vue&type=template&id=50622db3&scoped=true&ts=true"
import script from "./AdmCreateCourt.vue?vue&type=script&lang=ts"
export * from "./AdmCreateCourt.vue?vue&type=script&lang=ts"

import "./AdmCreateCourt.vue?vue&type=style&index=0&id=50622db3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50622db3"]])

export default __exports__